import $ from 'jquery';
window.$ = window.jQuery = $;
import { default as Common } from './modules/common.js';
import { default as Accordion } from './modules/accordion.js';
import { default as Collapse } from './modules/collapse.js';
import { default as Drawer } from './modules/drawer.js';
import { default as Dropdown } from './modules/dropdown.js';
import { default as Header } from './modules/header.js';
import { default as Filters } from './modules/filters.js';
import { default as Footer } from './modules/footer.js';
import { default as Tel } from './modules/tel.js';
import { default as Modal } from './modules/modal.js';
import { default as Form } from './modules/form.js';
import { default as Nav } from './modules/nav.js';
import { default as Ribbon } from './modules/ribbon.js';
import { default as Slider } from './modules/slider.js';
import { default as Stats } from './modules/stats.js';
import { default as Tabs } from './modules/tabs.js';
import { default as Tooltip } from './modules/tooltip.js';
import { default as Video } from './modules/video.js';

const modules = {
  Common,
  Accordion,
  Collapse,
  Drawer,
  Dropdown,
  Header,
  Filters,
  Footer,
  Tel,
  Modal,
  Form,
  Nav,
  Ribbon,
  Slider,
  Stats,
  Tabs,
  Tooltip,
  Video,
};

Object.keys(modules).forEach(key => {
  modules[key].init();
  window[key] = modules[key];
});
